import BaseResource from './index'

export default class ScheduleResource extends BaseResource {
    static endpoint = '/oasis/restv3/schedules'
    static cacheMaxAge = 1800
}
